import  './Product.css'
import pic from "../images/illustration-2.svg"
import icon from "../images/icon-arrow.svg"
import quoteicon from "../images/icon-quotes.svg"
import img from "../images/avatar-testimonial.jpg"
const Productive = () => {
    return (
        <section className="product">
               <div className="container px">
                   <div className="flex">
     <div className="product__image">
             <img src={pic} alt=""/>     
               </div>  
               
                <div className="product__text"> <h4>Stay productive, wherever you are</h4>
                     <div className="first___text">
                        Never let location be an issue when accessing your files. Fylo has you covered for all of your file storage needs.
                    </div> 
                     <div className="second___text">
        Securely share files and folders with friends, family and colleagues for live collaboration. No email attachments required!.
                    </div> 
                     <div className="check__how">
                        <a href=""> See how Fylo works</a>
                         <div className="icon__div">
                     <img src={icon} alt=""/>
                        </div>    
                    </div> 
                    <div className="quote">
                        <div className="quote__icon">
                            <img src={quoteicon} alt=""/>
                        </div>
                        <div className="quote__text">
                            Fylo has improved our team productivity by an order of magnitude. Since making the switch our team has become a well-oiled collaboration machine.
                    </div>
                        <div className="quote__flex">
                        <div className="img">
                            <img src={img} alt=""/>
                        </div>
                        <div className="quote__name">
                            Kyle Burton
                                 <div className="quote__position">
                                    Founder & CEO, Huddle
                                </div>
                            </div>
                            </div>
                    </div>
                </div>
                </div>
           </div>
        </section>
    )
}

export default Productive
